import { z } from 'zod';

export const SyncableEntitySchema = z.object({
  id: z.string().uuid(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  deletedAt: z.string().datetime().nullable().default(null),
  version: z.number().int().nonnegative().default(1),
  originDeviceId: z.string(),
  schemaVersion: z.number().int().default(1),
});

export type SyncableEntity = z.infer<typeof SyncableEntitySchema>;
